import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail8 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>了解SOLID開發原則，創建明確及有效地設計程式架構</li>
          <li>
            學習使用13種常用的軟體設計模式，包含觀察者模式、組合模式、工廠模式、策略模式、單例模式等等
          </li>
          <li>在專案中實際使用設計模式，使程式架構更容易維護且易於擴展</li>
          <li>使用Android Studio開發應用程式</li>
          <li>透過設計模式解決物件導向中的耦合問題</li>
          <li>以Kotlin語法，撰寫Android平台的應用程式</li>
          <li>實作功能強大的Android應用程式！！</li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>對Android應用程式開發有興趣，但沒有經驗的人</li>
          <li>想要轉職成為Android軟體工程師的人</li>
          <li>已經了解Java語言，希望實際應用的人</li>
          <li>大學資工系、資管系主修或副修學生</li>
          <li> 對於資訊科技有興趣，想要開始動手寫程式者</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail8;
